import { Button } from "primereact/button";
import { useForm } from 'react-hook-form';
import { Fetch, baseUrl } from "../../../shared/Fetch";
import { JVDate } from "../../../shared/JVDate";
import { IUsersDropdown, ICompanyMastDropdown, IBranchMastDropdown, ITeamsDropdown, IIndustryMastDropdown } from "../../../models/IDropdown";
import { JVDropdown } from "../../../shared/JVDropdown";
import { useEffect, useState } from "react";
import { ILogin } from "../../../models/Login";
import { JVCheckbox } from "../../../shared/JVCheckbox";
import { MultiSelect } from "primereact/multiselect";
import { Dropdown } from "primereact/dropdown";
import { Publish_Type } from "../../../models/RequirementMast";
import { format } from "date-fns";

export interface ISalEffFilter {
    fromDate?: Date | string | null,
    toDate?: Date | string | null,
    company?: number | null,
    branch?: number[] | null,
    team?: number | null,
    salesManager?: number | null,
    activeUser?: boolean | null,
    publish_Type?: Publish_Type | null,
    user_Status?: boolean | null,
    frequency?: number | null,
    exclude_From_Report?: boolean | null,
    agreegate_Report?: boolean | null,
    teamIDs?: number[] | null,
    industry_Id: number | null
}

export const EmptySalEffFilter: ISalEffFilter = {
    fromDate: new Date,
    toDate: new Date,
    company: null,
    branch: null,
    team: null,
    salesManager: null,
    publish_Type: null,
    user_Status: true,
    frequency: null,
    exclude_From_Report: null,
    agreegate_Report: null,
    industry_Id: null
}

interface Iprops {
    setSalEffFilter: (salEffFilter: ISalEffFilter) => void;
    onSearch: () => void;
    toast: any;
}

export const Filter = (props: Iprops) => {
    const [companies, setCompanies] = useState<Array<ICompanyMastDropdown>>();
    const [branches, setBranches] = useState<Array<IBranchMastDropdown>>();
    const [team, setTeam] = useState<Array<ITeamsDropdown>>();
    const [sm, setSM] = useState<Array<IUsersDropdown>>();
    const [excel, setExcel] = useState<{ show: boolean, num: number | null }>({ show: false, num: null });
    const [excelLoading, setExcelLoading] = useState<boolean>(false);

    const [selectedBranch, setSelectedBranch] = useState<Array<number>>([]);
    const [selectedTeams, setSelectedTeams] = useState<Array<number>>([]);
    const [selectedSm, setselectedSm] = useState<number | null>(null);

    const [industry, setIndustry] = useState<Array<IIndustryMastDropdown>>();

    const { control, handleSubmit, reset, watch } = useForm<ISalEffFilter>({
        defaultValues: EmptySalEffFilter,
        shouldFocusError: false
    });


    const downloadExcel = async (exceltype: number) => {
        setExcelLoading(p => p = true);
        const params = {
            method: "GET",
            headers: {
                'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
            }
        };
        try {
            const filter = { ...control._formValues };
            if (selectedBranch.length > 0) filter.branch = selectedBranch;
            if (selectedTeams.length > 0) filter.teamIDs = selectedTeams;
            delete filter.frequency;
            if (selectedSm) filter.salesManager = selectedSm;

            filter.fromDate = filter.fromDate ? format(new Date(filter.fromDate), 'yyyy-MM-dd') : null;
            filter.toDate = filter.toDate ? format(new Date(filter.toDate), 'yyyy-MM-dd') : null;
            const response = await fetch(`${baseUrl}${"Report_Sales_Efficiency/getexcel"}?` + `filter=` + encodeURIComponent(JSON.stringify(filter)) + `&exceltype=${exceltype}`, params);
            if (response.ok) {
                const blob = await response.blob();
                const href = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.download = `SalesEfficiencyReport.xlsx`;
                a.href = href;
                a.click();
                a.href = '';
                setExcelLoading(p => p = false);
            } else {
                const message = await response.text();
                props.toast.current.show({ severity: 'error', detail: message, life: 3000 });
                setExcelLoading(p => p = false);
            }
        } catch {
            setExcelLoading(p => p = false);
            props.toast.current.show({ severity: 'error', detail: 'Something went Wrong', life: 3000 });
        }
    }

    const _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const Publish_Type_Options = [
        { name: "-- SELECT --", id: null },
        { name: 'Normal', id: Publish_Type.Normal },
        { name: 'Skill', id: Publish_Type.Skill },
        { name: 'Branch', id: Publish_Type.Branch },
        { name: 'Company', id: Publish_Type.Company },
        { name: 'Global', id: Publish_Type.Globally }
    ];

    const sales_Status = [
        { label: "-- SELECT --", status: null },
        { label: 'Active', status: true },
        { label: 'Inactive', status: false },
    ];

    const loadBranches = async (company?: number | null | undefined) => {
        let queryParam = company ? `company_id=${company}` : null;
        let endPoint = loginObj.id === 1346 ? "allBranches" : "reqBranchList";

        const response = await Fetch(`Dropdown/${endPoint}`, "GET", null, queryParam, null);
        if (response) {
            const data: Array<IBranchMastDropdown> = await response.json();
            const emptyData = {
                branch_ID: 0,
                branchName: "-- SELECT --",
                company_ID: 0
            };
            data.unshift(emptyData);
            setBranches(data);
        }
    };

    const loadCompanies = async () => {
        let endPoint = loginObj.id === 1346 ? "company" : "reqCompanyList";

        const response = await Fetch(`Dropdown/${endPoint}`, "GET", null, null, null);
        if (response) {
            const data: Array<ICompanyMastDropdown> = await response.json();
            const emptyData = {
                company_ID: 0,
                company_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setCompanies(data);
        }
    };

    const loadTeam = async (branch: number[] | null | undefined, company: number | null | undefined, type: string = "sales") => {
        let queryParameter = null;
        if (branch && branch.length > 0 && branch[0] != 0) {
            queryParameter = branch.map(b => `branch_ID=${b}`).join("&");

        } else if (company != 0 && company != null) {
            queryParameter = `company_ID=${company}`;
        }

        if (type && type != "" && type != "-- SELECT --") {
            if (type === "sales") queryParameter = "user_Type=sales&" + queryParameter;
            if (type === "recruiter") queryParameter = "user_Type=recruiter&" + queryParameter;
        }

        const response = await Fetch("Dropdown/filterTeamsBranchList", "GET", null, queryParameter, null);
        if (response) {
            const data: Array<ITeamsDropdown> = await response.json();
            const emptyData = {
                team_ID: 0,
                team_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setTeam(data);
        }
    }

    const loadSm = async (branches: number[] | null | undefined, company: number | null | undefined, team: number | null | undefined, teams: number[] | null | undefined) => {
        let queryParameter = null;

        if (team !== 0 && team !== null) {
            queryParameter = `team_ID=${team}`;
        } else if (teams && teams.length > 0 && teams[0] != 0) {
            queryParameter = `&teamIDs=` + teams;
        } else if (branches && branches.length > 0 && branches[0] != 0) {
            queryParameter = branches.map(b => `branch_ID=${b}`).join("&");
        } else if (company !== 0 && company !== null) {
            queryParameter = `company_ID=${company}`;
        }

        try {
            const response = await Fetch("Dropdown/filterUsersListss", "GET", null, queryParameter, null);
            if (response) {
                const data: Array<IUsersDropdown> = await response.json();

                const emptyData = {
                    login_ID: 0,
                    user_Name: "-- SELECT --"
                };
                data.unshift(emptyData);
                setSM(data);
            }
        } catch (error) {
            console.error("Error fetching SM:", error);
        }
    };

    const searchToDB = async (body: ISalEffFilter) => {
        let filterData: any = body;
        let emptyFilter: any = EmptySalEffFilter;
        for (let key in filterData) {
            if (filterData[key] === "-- SELECT --" || filterData[key] === 0) {
                if (key !== 'publish_Type') filterData[key] = emptyFilter[key];
            }
        }
        if (body.industry_Id === 0) {
            body.industry_Id = null;
        }

        body = filterData;
        props.setSalEffFilter(body);
    }

    function onSubmit(data: ISalEffFilter) {
        if (selectedBranch.length > 0) data.branch = selectedBranch;
        if (selectedTeams.length > 0) data.teamIDs = selectedTeams;
        delete data.frequency;
        if (selectedSm) data.salesManager = selectedSm;
        searchToDB(data);
        props.onSearch();
    }

    const loadIndsutry = async () => {
        const response = await Fetch("Dropdown/industries", "GET", null, null, null);
        if (response) {
            let data: Array<IIndustryMastDropdown> = await response.json();
            data.unshift({
                industry_Id: 0,
                industry_Name: "--SELECT--",
            });
            setIndustry(data);
        }
    }

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "company") {
                if (value.company != 0 && value.company != null) {
                    loadTeam([], value.company);
                    loadSm([], value.company, 0, []);
                    loadBranches(value.company);
                } else {
                    if (value.company === 0 && value.company != null) {
                        loadBranches();
                        loadTeam(control._formValues.branch, value.company);
                        loadSm(control._formValues.branch, value.company, 0, [control._formValues.team]);
                    }
                }
            }

            if (name === "branch") {
                if (value.branch != null && value.branch != null) {
                    loadTeam([], null);
                    loadSm([], 0, 0, []);
                } else {
                    if (value.branch === null && value.branch != null) {
                        loadTeam(value.branch, control._formValues.company);
                        loadSm(value.branch, control._formValues.company, 0, [control._formValues.team]);
                    }
                }
            }

            if (name === "team") {
                if (value.team) {
                    loadSm([], 0, 0, [value.team]);
                } else if (value.team === 0) {
                    loadSm(control._formValues.branch, control._formValues.company, 0, [value.team]);
                }
            }
            if (name === "frequency") {
                if (value.frequency) {
                    setExcel(prev => ({ ...prev, show: true, num: value?.frequency || 0 }));
                } else {
                    setExcel(prev => ({ ...prev, show: false, num: null }));
                }
            }
        });
        return () => subscription.unsubscribe();
    }, [watch]);

    useEffect(() => {
        if (selectedBranch.length > 0) {
            loadTeam(selectedBranch, 0);
            loadSm(selectedBranch, 0, 0, []);
        }
    }, [selectedBranch]);

    useEffect(() => {
        if (selectedTeams.length > 0) {
            loadSm([], 0, 0, selectedTeams);
        }
    }, [selectedTeams]);

    useEffect(() => {
        loadTeam([], 0);
        loadSm([], 0, 0, []);
        loadCompanies();
        loadBranches();
        loadIndsutry();
    }, []);

    return (
        <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">

            <JVDate maxDate={new Date} column={6} label="From Date" control={control} name="fromDate" />
            <JVDate maxDate={new Date} column={6} label="To Date" control={control} name="toDate" />
            <JVDropdown column={6} label="Company" control={control} name="company" options={companies} optionLabel="company_Name" optionValue="company_ID" placeholder="Select Company" />
            <div className="field col-2 md:col-2">
                <p>Branch</p>
                <MultiSelect className="" style={{ height: "37px", marginTop: "-10px" }} value={selectedBranch} onChange={(e) => setSelectedBranch(e.value)} options={branches} optionValue="branch_ID" optionLabel="branchName" display="chip" filter placeholder="Select Branches" />
            </div>
            <div className="field col-2 md:col-2">
                <p>Teams</p>
                <MultiSelect className="" style={{ height: "37px", marginTop: "-10px" }} value={selectedTeams} onChange={(e) => setSelectedTeams(e.value)} options={team} optionValue="team_ID" optionLabel="team_Name" display="chip" filter placeholder="Select Team" />
            </div>
            <div className="field col-2 md:col-2">
                <p>Sales Manager</p>
                <Dropdown value={selectedSm} style={{ height: "37px", marginTop: "-10px" }} onChange={(e) => { setselectedSm(e.value); }} options={sm} optionLabel="user_Name" placeholder="Select Sales Manager" optionValue="login_ID" filter />
            </div>
            <JVDropdown column={6} label="Sales Status" control={control} name="user_Status" options={sales_Status} optionLabel="label" optionValue="status" placeholder="Select Sales Status" />
            <JVDropdown column={6} label="Publish Scope" control={control} name="publish_Type" options={Publish_Type_Options} optionLabel="name" optionValue="id" placeholder="Select Publish Scope" />
            <JVDropdown column={6} required label="Industry Type" control={control} name="industry_Id" options={industry} optionLabel="industry_Name" optionValue="industry_Id" placeholder="Select Industry Type" />
            {(_roles.includes(1) || _roles.includes(20) || _roles.includes(26) || _roles.includes(40) || _roles.includes(5)) && <JVDropdown column={6} label="Frequency" control={control} name="frequency" options={[{ label: "--SELECT--", value: 0 }, { label: "Daily", value: 4 }, { label: "Weekly", value: 1 }, { label: "Monthly", value: 2 }, { label: "Quarterly", value: 3 }]} optionLabel="label" optionValue="value" placeholder="Select Type Of Excel" />}
            <div className="col-6" style={{ display: "flex", gap: "40px", alignItems: "center", marginTop: "10px" }}>
                <p style={{ color: 'white' }}>.</p>
                <JVCheckbox column={4} label="Show Excluded User" control={control} name="exclude_From_Report" />
                <p style={{ color: 'white' }}>.</p>
                <JVCheckbox column={4} label="Combined Report" control={control} name="agreegate_Report" />
            </div>
            <div style={{ margin: '10px 0', width: '100%' }}></div>

            <div className="col-12 md:col-12" style={{ display: "flex", gap: "10px", marginTop: "10px", flexWrap: "nowrap" }}>
                <Button className="field" label="SEARCH" type="submit" style={{ height: "30px" }} />
                {excel.show && (
                    <Button className="field" loading={excelLoading} disabled={excelLoading} style={{ backgroundColor: "#9c27b0", height: "30px" }} label="GET EXCEL" onClick={() => { downloadExcel(excel.num || 0); }} />)}
                <Button className="field p-button-outlined" label="CLEAR" style={{ height: "30px" }} onClick={() => { reset(EmptySalEffFilter); setExcel(prev => ({ ...prev, show: false, num: null })); setSelectedBranch([]); setselectedSm(null); }} type="button" />
            </div>
        </form>
    );
}
